import { motion } from "framer-motion";
import { Reveal } from "./Motion";

const STEPS = [
  { n: "01", title: "Listen", body: "I learn what you need people to feel and do." },
  { n: "02", title: "Shape", body: "I build the story first, then design every frame or page around it." },
  { n: "03", title: "Deliver", body: "Final files, ready for the stage or ready to launch." },
];

export default function HowIWork() {
  return (
    <section id="process" className="relative py-24 md:py-36 scroll-mt-20" data-testid="how-i-work">
      <div className="max-w-[1600px] mx-auto px-6 md:px-12">
        <Reveal className="max-w-3xl mb-16 md:mb-20">
          <p className="text-xs uppercase tracking-[0.3em] text-white/40 mb-4">How I work</p>
          <h2 className="font-display font-bold text-4xl md:text-6xl tracking-tight leading-[0.95]">
            A creative strategist who <span className="font-serif-accent italic font-normal">solves problems</span>
          </h2>
          <p className="text-white/55 mt-6 max-w-xl leading-relaxed">
            Keynote or website, the job is the same: work out what the brand needs to say, then make it land. Here is how every project runs.
          </p>
        </Reveal>

        <div className="grid md:grid-cols-3 gap-px bg-white/10 border border-white/10 rounded-2xl overflow-hidden">
          {STEPS.map((s, i) => (
            <motion.div
              key={s.n}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.6, delay: i * 0.08, ease: [0.22, 1, 0.36, 1] }}
              className="bg-[#090909] p-8 md:p-12"
              data-testid={`step-${s.n}`}
            >
              <span className="font-serif-accent text-5xl md:text-6xl text-white/25 leading-none block mb-6">{s.n}</span>
              <h3 className="font-display font-bold text-2xl md:text-3xl tracking-tight mb-3">{s.title}</h3>
              <p className="text-white/55 leading-relaxed">{s.body}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
